import { render } from "./ChallengesSection.vue?vue&type=template&id=d1e67748&scoped=true"
import script from "./ChallengesSection.vue?vue&type=script&lang=js"
export * from "./ChallengesSection.vue?vue&type=script&lang=js"

import "./ChallengesSection.vue?vue&type=style&index=0&id=d1e67748&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1e67748"]])

export default __exports__